import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["selectAll", "checkbox", "selectedCount"]
  static values = {
    selected: Array
  }

  connect() {
    this.updateSelectedCount()
    this.updateSelectAllState()
  }

  toggleAll(event) {
    const checked = event.target.checked
    this.checkboxTargets.forEach(checkbox => {
      checkbox.checked = checked
    })
    this.updateSelectedCount()
  }

  toggleItem(event) {
    this.updateSelectedCount()
    this.updateSelectAllState()
  }

  updateSelectedCount() {
    const count = this.checkboxTargets.filter(cb => cb.checked).length
    if (this.hasSelectedCountTarget) {
      const text = this.selectedCountTarget.textContent
      // Update just the number in the existing translation
      this.selectedCountTarget.textContent = text.replace(/\d+/, count)
    }
  }

  updateSelectAllState() {
    if (this.hasSelectAllTarget) {
      const allChecked = this.checkboxTargets.every(cb => cb.checked)
      const someChecked = this.checkboxTargets.some(cb => cb.checked)
      
      this.selectAllTarget.checked = allChecked
      this.selectAllTarget.indeterminate = someChecked && !allChecked
    }
  }
}